'use strict';
module.exports = require('./DataView.vue');